module.exports = __webpack_public_path__ + "img/master.052ca510.png";